import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FormLabel } from 'src/components/FormLabel';
import { Icon } from 'src/components/Icon';
import { Stack } from 'src/components/Stack';
import { Tooltip } from 'src/components/Tooltip';

export const TooltipLabel = ({
  text,
  tooltip,
}: {
  text: string;
  tooltip: string;
}) => {
  return (
    <Stack direction="row" alignItems="center" sx={{ mb: 1, gap: 0.5 }}>
      <FormLabel>{text}</FormLabel>
      <Tooltip title={tooltip}>
        <Icon
          size="small"
          icon={faQuestionCircle}
        />
      </Tooltip>
    </Stack>
  );
};
